module.exports = __webpack_public_path__ + "static/media/SaaSbg2.9c1b47e8.png";